import { useMemo } from 'react'

import { y } from '@circlefin/form'
import { L3OnboardingPhysicalPresenceOrService } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import { requiredMessage } from '../../../yup/utils'
import { L3OnboardingMultiSelectCombobox } from '../../L3OnboardingMultiSelectCombobox'

import type { L3OnboardingMultiSelectComboboxVariantProps } from '../types'
import type { MultiSelectComboboxItem } from '@circlefin/components/lib/MultiSelectCombobox'

export const physicalPresenceOrServiceSchema = y
  .array()
  .of(y.mixed<L3OnboardingPhysicalPresenceOrService>())
  .min(1, requiredMessage)

export const PhysicalPresenceOrService: React.FC<
  L3OnboardingMultiSelectComboboxVariantProps
> = (props) => {
  const { t } = useTranslation('l3Onboarding')

  const items: Array<
    MultiSelectComboboxItem<L3OnboardingPhysicalPresenceOrService>
  > = useMemo(() => {
    const data = Object.values(L3OnboardingPhysicalPresenceOrService)
      .filter(
        (value) =>
          value !== L3OnboardingPhysicalPresenceOrService.notApplicable,
      )
      .map((option) => ({
        label: t(`countries:${L3OnboardingPhysicalPresenceOrService[option]}`),
        value: L3OnboardingPhysicalPresenceOrService[option],
      }))

    return [
      // Ensure 'Not applicable' option is the first to appear in the dropdown
      // Because generated GQL enums are sorted alphabetically
      {
        label: t(
          `forms.entityOperations.countriesWithPhysicalPresence.options.${L3OnboardingPhysicalPresenceOrService.notApplicable}`,
        ),
        value: L3OnboardingPhysicalPresenceOrService.notApplicable,
        selectAll: true,
      },
      ...data,
    ]
  }, [t])

  return (
    <L3OnboardingMultiSelectCombobox
      items={items}
      label={t`forms.entityOperations.countriesWithPhysicalPresence.label`}
      {...props}
    />
  )
}
